const TIERS = [
  { key: "bronze", label: "Bronze", threshold: 5 },
  { key: "silver", label: "Silver", threshold: 15 },
  { key: "gold", label: "Gold", threshold: 40 },
  { key: "platinum", label: "Platinum", threshold: 100 },
];

export default function WorkerProgressBar({ count }) {
  const next = TIERS.find(t => count < t.threshold);

  if (!next) {
    return (
      <p className="text-xs text-muted-foreground">
        🏆 You've reached the top tier — Platinum.
      </p>
    );
  }

  const prevThreshold = TIERS[TIERS.indexOf(next) - 1]?.threshold || 0;
  const span = next.threshold - prevThreshold;
  const progressInSpan = count - prevThreshold;
  const pct = Math.min(100, Math.round((progressInSpan / span) * 100));
  const remaining = next.threshold - count;

  return (
    <div>
      <div className="h-2 rounded-full bg-muted overflow-hidden">
        <div
          className="h-full rounded-full bg-brand transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
      <p className="text-xs text-muted-foreground mt-2">
        {remaining} more job{remaining !== 1 ? "s" : ""} to reach <span className="font-medium text-foreground">{next.label}</span>
      </p>
    </div>
  );
}